// sessions/columns/sessionColumns.js
import { StatusCell, EllipsisLinkCell } from "./renderers";

import { formatEnergy } from "../utils/energy";
import { calculateRevenue } from "../utils/revenue";
import { AutoTooltip, convertUTCtoDubai } from "../../utils/Constant";

export const createSessionColumns = ({
  statusColorMap,
  onSessionClick,
  showRevenue = false,
  showAction = false,
  actionRenderer,
}) => [
  /* ================= SESSION ID ================= */
  {
    header: "Session ID",
    accessorKey: "sessionId",
    size: 220,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: EllipsisLinkCell({ onClick: onSessionClick }),
  },

  /* ================= STATUS ================= */
  {
    header: "Status",
    accessorKey: "status",
    size:200,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: StatusCell(statusColorMap),
  },
  /* ================= DURATION ================= */
  {
    header: "Duration",
    accessorKey: "duration",
    size: 210,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => cell.getValue() || "—",
  },
  /* ================= ENERGY ================= */
  {
    header: "Energy Dispensed",
    accessorKey: "energyFromMeta",
    size: 250,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: {
      align: "center",
      style: { fontVariantNumeric: "tabular-nums" },
    },
    Cell: ({ cell }) => (
      <AutoTooltip maxWidth={120}>
        <span
          style={{
            display: "block",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {formatEnergy(cell.getValue())}
        </span>
      </AutoTooltip>
    ),
  },

  /* ================= Vehicle ID ================= */
  {
    header: "Vehicle ID",
    accessorKey: "vehicleId",
    size: 220,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },

  /* ================= CHARGER ID ================= */
  {
    header: "Charger ID",
    accessorKey: "chargerId",
    size: 230,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
  {
    header: "Start SOC (%)",
    accessorKey: "startSOC",
    size: 230,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
  },
  {
    header: "End SOC (%)",
    accessorKey: "finalSOC",
    size: 230,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value === null || value === undefined ? "N/A" : value;
    },
  },

  /* ================= CHARGER NAME ================= */
  {
    header: "Charger Name",
    accessorKey: "chargerName",
    size: 200,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => (
      <AutoTooltip maxWidth={180}>
        <span
          style={{
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {cell.getValue() || "—"}
        </span>
      </AutoTooltip>
    ),
  },
  {
    header: "Start Date & Time",
    accessorKey: "createdAt",
    align: "center",
    muiTableHeadCellProps: {
      align: "center",
    },
    size: 280,

    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => convertUTCtoDubai(cell.getValue()),
  },
  {
    header: "End Date & Time",
    accessorKey: "endTime",
    align: "center",
    muiTableHeadCellProps: {
      align: "center",
    },
    size: 260,

    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => convertUTCtoDubai(cell.getValue()),
  },

  /* ================= LOCATION ================= */
  {
    header: "Location",
    accessorKey: "locationName",
    id: "locationName",
    size: 200,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => (
      <AutoTooltip maxWidth={220}>{cell.getValue() || "—"}</AutoTooltip>
    ),
  },
    /* ================= LOCATION ================= */
  {
    header: "Location",
    accessorKey: "locationName",
    id: "locationName",
    size: 200,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => (
      <AutoTooltip maxWidth={220}>{cell.getValue() || "—"}</AutoTooltip>
    ),
  },

      /* ================= ADDRESS ================= */
      {
        header: "Address",
        accessorKey: "address",
        id: "address",
        size: 220,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ cell }) => (
          <AutoTooltip maxWidth={220}>{cell.getValue() || "—"}</AutoTooltip>
        ),
      },

      /* ================= CITY ================= */
      {
        header: "City",
        accessorKey: "city",
        id: "city",
        size: 150,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ cell }) => (
          <AutoTooltip maxWidth={150}>{cell.getValue() || "—"}</AutoTooltip>
        ),
      },

      /* ================= STATE ================= */
      {
        header: "State", 
        accessorKey: "state",
        id: "state",
        size: 150,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ cell }) => (
          <AutoTooltip maxWidth={150}>{cell.getValue() || "—"}</AutoTooltip>
        ),
      },

  /* ================= REVENUE ================= */
  ...(showRevenue
    ? [
        {
          header: "Revenue",
          size: 140,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: {
            align: "center",
            style: { fontVariantNumeric: "tabular-nums" },
          },
          Cell: calculateRevenue,
        },
      ]
    : []),

      /* ================= Session wait time ================= */
  {
    header: "Session Wait Time",
    accessorKey: "sessionWaitTime",
    size: 120,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => cell.getValue() || "—",
  },
  {
    header: "Cost",
    accessorKey: "totalRevenue",
    size: 180,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => cell.getValue() || "—",
  },
  {
    header: "CO2 Saved",
    accessorKey: "co2Saved",
    size: 200,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => cell.getValue() || "—",
  },


  /* ================= ACTION ================= */
  ...(showAction
    ? [
        {
          header: "Action",
          size: 90,
          enableColumnFilter: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { align: "center" },
          Cell: actionRenderer,
        },
      ]
    : []),
];
